import { trackDownloadAppClick } from './analytics';

export function handleDownloadAppClick(e: MouseEvent) {
  e.preventDefault();

  const currentTarget = e.currentTarget as HTMLAnchorElement;
  const href = currentTarget.href;
  const gaLabel = currentTarget.dataset.gaLabel || '';

  trackDownloadAppClick(gaLabel);

  setTimeout(() => {
    window.location.href = href;
  }, 300);
}
